import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const StyledImage = styled.img`
  width: 60%;
  max-width: 250px;
  display: block;
  height: auto;
  margin: 0 auto;
`;

function ErrorImage({alt = '', src}) {
  return <StyledImage src={src} alt={alt} />;
}

ErrorImage.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
};

ErrorImage.defaultProps = {
  alt: '',
};

export default ErrorImage;
